(() => {
  if (window.prop65PlacementInitialized) return;
  window.prop65PlacementInitialized = true;

  const desktopQuery = window.matchMedia('(min-width: 990px)');
  const gap = 12;
  const tolerance = 8;

  const restore = (productInfo, warning) => {
    const anchor = productInfo.querySelector('[data-prop65-placement-anchor]');
    if (anchor && warning.previousElementSibling !== anchor) anchor.after(warning);
    warning.removeAttribute('data-prop65-column');
  };

  const naturalBottom = (column) => {
    const top = column.getBoundingClientRect().top;
    const content = [...column.querySelectorAll('*')].filter((element) => (
      !element.closest('[data-prop65-warning]')
      && !element.hidden
      && getComputedStyle(element).display !== 'none'
    ));
    if (!content.length) return 0;
    return Math.max(...content.map((element) => element.getBoundingClientRect().bottom - top));
  };

  const place = (productInfo) => {
    const product = productInfo.querySelector('.product');
    const warning = productInfo.querySelector('[data-prop65-warning="product"]');
    if (!product || !warning) return;
    if (!desktopQuery.matches) {
      restore(productInfo, warning);
      return;
    }

    const columns = [
      product.querySelector(':scope > .product__media-wrapper'),
      product.querySelector(':scope > .product__info-wrapper'),
      product.querySelector(':scope > .product__3d-wrapper'),
    ].filter((column) => (
      column
      && getComputedStyle(column).display !== 'none'
      && column.getBoundingClientRect().width > 0
      && !column.querySelector('canvas, model-viewer')
    ));
    if (columns.length < 2) {
      restore(productInfo, warning);
      return;
    }

    const heights = columns.map((column) => ({ column, height: naturalBottom(column) }));
    const shortest = heights.reduce((current, candidate) => candidate.height < current.height ? candidate : current);
    const tallestHeight = Math.max(...heights.map(({ height }) => height));
    const warningHeight = warning.getBoundingClientRect().height || warning.scrollHeight;

    if (shortest.height + gap + warningHeight <= tallestHeight + tolerance) {
      if (warning.parentElement !== shortest.column) shortest.column.append(warning);
      warning.dataset.prop65Column = shortest.column.className;
    } else {
      restore(productInfo, warning);
    }
  };

  let frame;
  const arrangeAll = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => document.querySelectorAll('product-info').forEach(place));
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrangeAll, { once: true });
  else arrangeAll();
  window.addEventListener('resize', arrangeAll, { passive: true });
  document.addEventListener('product-info:loaded', arrangeAll);
  document.addEventListener('shopify:section:load', arrangeAll);
  document.addEventListener('change', (event) => {
    if (event.target.matches('variant-selects input[type="radio"]')) window.setTimeout(arrangeAll, 0);
  });
})();
